import { useContext, useState } from "react";
import BackButton from "../CommonComponents/BackButton/BackButton";
import { AppContext } from "../Context/AppContext";
import ThemeControl from "../CommonComponents/ThemeControl/ThemeControl";
import "./UploadFiles.scss";
import UploadTable from "./UploadTable";
import FileLoad from "./Dialogs/FileLoad";

export default function UploaderLayout(props) {
	//contexts
	const { theme } = useContext(AppContext);

	//states
	const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [load, setLoad] = useState(false);

	//components
	const getCurrentTable = () => (
		<UploadTable
			rowSelectionModel={rowSelectionModel}
			setRowSelectionModel={setRowSelectionModel}
		/>
	);

	//#region
	const handleFileLoad = () => setLoad(true);
	//#endregion

	return (
		<>
			<div className='main-container' color={theme.color} data-type='upload'>
				<div
					className='head'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.headerFontMultiplier
						}px`,
					}}
				>
					<div className='navigation-header'>
						<BackButton />
					</div>
					<div className='content-header'>
						<button onClick={handleFileLoad}>Загрузить файл</button>
					</div>
					<div className='support-header'>
						<ThemeControl />
					</div>
				</div>
				<div className='body'>
					<div
						className='navigation-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
							}px`,
						}}
					>
						{/* <div>
							<button
								disabled={rowSelectionModel.length === 0}
								style={{ fontSize: "1em" }}
								onClick={() => {
									setEditable((prev) => !prev);
								}}
							>
								{`Корректировать выделенную стороку`}
							</button>
						</div> */}
					</div>
					<div
						className='content-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
							}px`,
						}}
					>
						{getCurrentTable()}
					</div>
					{false ? (
						<div
							className='support-column'
							style={{
								fontSize: `${
									(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
								}px`,
							}}
						></div>
					) : null}
				</div>
			</div>
			{load ? <FileLoad setLoad={setLoad} /> : null}
		</>
	);
}
